import { createStructuredSelector } from 'reselect';

/** Carousel State Selector */
const getCarouselStates = (state) => state.carousel.carouselData;

export const getCarouselData = (state) => {
  const { data } = getCarouselStates(state);
  return data;
};

export const getCarouselLoadingStatus = (state) => {
  const { isLoading } = getCarouselStates(state);
  return isLoading;
};

export const carouselStates = createStructuredSelector({
  carouselData: getCarouselData,
  isLoadingCarousel: getCarouselLoadingStatus,
});
